import {
  getGetApiEasyAdministrationAreaQueryKey,
  getGetApiQuoteApiGetQuoteIdQueryKey,
} from "../openapi/backendApi";
import { useAtomCallback } from "jotai/utils";

import { useCallback } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { maintenanceModeAtom } from "./maintenanceMode";

export function useSetMaintenanceMode(): (isActive: boolean) => void {
  const queryClient = useQueryClient();

  return useAtomCallback(
    useCallback(
      (get, set, isActive: boolean) => {
        const wasActive = get(maintenanceModeAtom);
        set(maintenanceModeAtom, isActive);
        if (wasActive && !isActive) {
          queryClient.invalidateQueries({
            queryKey: getGetApiEasyAdministrationAreaQueryKey(),
          });
          queryClient.invalidateQueries({
            queryKey: getGetApiQuoteApiGetQuoteIdQueryKey(),
          });
        }
      },
      [queryClient],
    ),
  );
}
